module.exports = __webpack_public_path__ + "static/media/doc-pic-3.a64623b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/doc-pic-3.jpg
// module id = 86
// module chunks = 0